<template>
    <div class="details-container">  
        <div class="block-page-title">
            <h2>Payment method</h2>
             <div class="btn-close" v-if="editPayment" @click="closeForm">
                <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.77402 4.81604C10.1733 6.25299 11.5029 7.77259 13.0051 9.09354C13.7243 9.72574 14.7495 10.2274 15.5745 8.93549C15.9762 8.30474 16.5837 7.80449 17.1043 7.23609C17.1782 7.23609 17.2464 7.25639 17.3131 7.25494C17.3363 7.25494 17.3566 7.19984 17.3783 7.16939C17.2725 7.21144 17.1681 7.25494 17.0622 7.29699C19.0647 5.27279 21.0671 3.24859 23.071 1.22584C23.1754 1.12144 23.2755 0.966294 23.4016 0.935844C24.7414 0.615394 26.6511 -0.380756 27.3108 0.155744C28.6347 1.23019 27.5936 2.86434 26.6366 4.01129C24.3557 6.74164 22.1619 9.57929 19.6026 12.0283C18.2831 13.2913 18.2817 13.9307 19.4736 15.0081C20.0608 15.5388 20.5727 16.155 21.1179 16.7321L21.0903 16.6828C23.2044 18.6345 25.4142 20.4949 27.4051 22.5655C29.2495 24.4838 28.9783 25.5162 26.5931 27.3577L26.6743 27.3345C25.8884 27.0315 25.0053 26.8662 24.3369 26.3964C23.1537 25.5641 22.0488 24.5998 21.0077 23.5921C18.9762 21.6273 17.0115 19.5959 15.0221 17.5949C15.0018 17.6282 14.9771 17.6601 14.9525 17.692C15.0003 17.6688 15.0467 17.6442 15.0946 17.621C12.3628 20.7675 9.64112 23.9241 6.88757 27.0518C6.28002 27.742 5.65362 28.6163 4.86047 28.8846C4.12242 29.1354 2.64052 28.9672 2.38532 28.496C1.86187 27.5303 1.40367 25.899 1.87782 25.1494C2.98562 23.3992 4.66037 22.0072 6.10022 20.4673C6.13212 20.4746 6.16837 20.4833 6.20317 20.4934C6.17272 20.5152 6.14082 20.5355 6.11037 20.5572C6.12632 20.534 6.14227 20.5094 6.15822 20.4862C7.68217 18.3416 9.20467 16.1956 10.8997 13.8089C9.04517 12.0631 7.04707 10.2115 5.08522 8.32214C3.83387 7.11864 2.58832 5.90354 1.42832 4.61304C0.340822 3.40374 -0.0274783 2.00159 1.21807 0.687894C2.51002 -0.675105 3.53807 0.376144 4.55017 1.22874C5.81022 2.29159 7.08477 3.33559 8.35207 4.38684L8.33032 4.37524C8.22447 4.43034 8.75372 5.00454 8.78562 4.83489L8.77547 4.81459L8.77402 4.81604Z" fill="#685BC7"></path></svg>
            </div>
        </div>
    </div>
    <div class="details-bg-grey">
        <div class="details-container">
            <div class="block-delivery-data">
                <div class="row-data payment">
                    <div class="data-key" v-if="!editPayment && typeCard"><strong>{{  typeCard }}</strong></div>
                    <div class="data-value pt-2" v-if="!editPayment && cardName">{{ cardName }}</div>
                    <div class="data-value" v-if="!editPayment">{{ numberCard ? viewCard : ' - ' }}</div>
                    <div class="data-value pt-1 pb-2" v-if="!editPayment && (monthCard || yearCard)">{{ monthCard ? monthCard + '/' : '' }}{{ yearCard }}</div>
                    <div class="data-edit mt-4" v-if="editPayment">
                        <v-form @submit.prevent @keyup.enter.prevent v-model="valid" ref="form" validation>
                            <v-radio-group inline v-model="typeCard">
                                <v-radio label="Visa" value="visa"></v-radio>
                                <v-radio label="Mastercard" value="mastercard"></v-radio>
                            </v-radio-group>
                            <v-text-field 
                                name="card-name" 
                                type="text" 
                                label="Full Name"
                                v-model="cardName" 
                                :rules="cardNameRules"  
                                @keyup.enter="savePaymentData"
                                required                            
                            ></v-text-field>
                            <v-text-field 
                                name="numder-card"
                                :counter="16" 
                                :maxlength="16" 
                                :minlength="16"                                   
                                label="Card number"
                                type="number"  
                                v-model="numberCard"
                                :rules="numberCardRules"
                                @keyup="checkValue('card')"
                                @keyup.enter="savePaymentData"
                                required                          
                            ></v-text-field>
                            <div class="row-card-data row-flex">                      
                                <v-text-field 
                                    name="card-month"                        
                                    v-model="monthCard" 
                                    :max="12"
                                    :min="1"
                                    type="number" 
                                    label="Month"
                                    maxlength="2"
                                    :rules="monthCardRules"
                                    @keyup="checkValue('month')"
                                    @keyup.enter="savePaymentData"
                                    required
                                >
                                    <span class="plus" @click="monthCard < 12 ? monthCard++ : 12"></span>
                                    <span class="minus"  @click="monthCard > 1 ? monthCard-- : 1"></span>
                                </v-text-field>
                                <v-text-field 
                                    name="card-year"                        
                                    v-model="yearCard"                                       
                                    maxlength="4"
                                    minlength="4"
                                    :max="fullYear + 20"
                                    :min="fullYear" 
                                    label="Year"
                                    type="year"
                                    :rules="yearCardRules"
                                    @keyup="checkValue('year')"
                                    required
                                    @keyup.enter="savePaymentData"
                                >
                                <span class="plus" @click="yearCard < fullYear + 20 ? yearCard++ : fullYear + 20"></span>
                                <span class="minus"  @click="yearCard > fullYear ? yearCard-- : fullYear"></span>
                            </v-text-field>
                            </div>
                            <div class="row-btn">
                                <v-btn type="submit" @click.prevent="savePaymentData" :disabled="!valid" class="btn btn-payment">Save payment method <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M16.052 20.508C14.677 19.157 12.133 16.359 10.792 14.974C10.17 14.331 9.55899 13.676 8.95999 13.012C8.54799 12.556 8.16899 12.379 7.45799 12.479C4.30899 12.923 2.08699 11.65 0.882992 8.99303C0.241992 7.57603 0.470992 6.22003 1.08799 4.91003C1.38899 4.27003 1.98799 4.59403 2.36999 4.87803C2.86599 5.24603 3.36099 5.67703 3.69999 6.18403C4.31299 7.10303 4.87299 6.99003 5.53599 6.29103C5.73799 6.07903 5.98899 5.91403 6.27399 5.68203C5.64599 4.88803 4.97499 4.16403 4.45899 3.34203C4.13499 2.82503 3.92199 2.16303 3.91999 1.56503C3.91999 1.38803 4.79199 1.10203 5.28399 1.04603C7.95899 0.739033 9.86799 1.90703 10.836 4.49403C11.178 5.40803 11.271 6.41303 11.548 7.35603C11.662 7.74603 11.898 8.14703 12.188 8.43003C13.676 9.88303 16.432 12.68 17.913 14.141C18.666 14.884 19.343 15.708 20.019 16.524C20.498 17.102 20.42 18.387 19.813 18.845C19.128 19.361 18.503 19.897 17.686 20.704C17.348 21.038 16.653 21.094 16.053 20.505L16.052 20.508Z"/>
                                    </svg>
                                </v-btn>
                            </div>
                        </v-form>
                    </div>
                </div>
                <div class="row-btn">
                    <div class="btn btn-edit-delivery" v-if="!editPayment" @click.prevent="setEditPayment">Edit payment method <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M16.052 20.508C14.677 19.157 12.133 16.359 10.792 14.974C10.17 14.331 9.55899 13.676 8.95999 13.012C8.54799 12.556 8.16899 12.379 7.45799 12.479C4.30899 12.923 2.08699 11.65 0.882992 8.99303C0.241992 7.57603 0.470992 6.22003 1.08799 4.91003C1.38899 4.27003 1.98799 4.59403 2.36999 4.87803C2.86599 5.24603 3.36099 5.67703 3.69999 6.18403C4.31299 7.10303 4.87299 6.99003 5.53599 6.29103C5.73799 6.07903 5.98899 5.91403 6.27399 5.68203C5.64599 4.88803 4.97499 4.16403 4.45899 3.34203C4.13499 2.82503 3.92199 2.16303 3.91999 1.56503C3.91999 1.38803 4.79199 1.10203 5.28399 1.04603C7.95899 0.739033 9.86799 1.90703 10.836 4.49403C11.178 5.40803 11.271 6.41303 11.548 7.35603C11.662 7.74603 11.898 8.14703 12.188 8.43003C13.676 9.88303 16.432 12.68 17.913 14.141C18.666 14.884 19.343 15.708 20.019 16.524C20.498 17.102 20.42 18.387 19.813 18.845C19.128 19.361 18.503 19.897 17.686 20.704C17.348 21.038 16.653 21.094 16.053 20.505L16.052 20.508Z"/>
import { triggerRef } from 'vue';
                        </svg>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>

export default {
    name: 'Payment-item',
    props: ['userDetails'],
    data() {
        return {
            typeCard: 'mastercard',            
            monthCard: '',
            yearCard: '',
            cardName: '',
            numberCard: '',
            valid: false,
            editPayment: false,           
            viewCard: '',
            fullYear: new Date().getFullYear(),
            cardNameRules: [
                v => !!v || 'Field is required',
            ],
            numberCardRules: [
                v => !!v || 'Field is required',
                v => (v && v.length == 16) || 'Card number is not valid, must be 16 characters'
            ],
            monthCardRules: [
                v => !!v || 'Field is required',
            ],
            yearCardRules: [
                v => !!v || 'Field is required',
            ],
        }
    },
    methods: {
        validateFormOnLoad() {
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.validate();
                }
            });
        },
        closeForm() {
            this.editPayment = false;
        },
        checkValue(label) {
            if ('year' == label && ( this.yearCard > this.fullYear + 20 || this.yearCard < this.fullYear) ) {
                this.yearCard = this.fullYear;
            }

            if ('month' == label && this.monthCard > 12) {
                this.monthCard = '';
            }

            if ('card' == label && this.numberCard.length > 16) {
                this.numberCard = this.numberCard.slice(0, -1);
            }
        },
        setEditPayment() {
           
            if ( this.numberCard && this.numberCard.length == 16 ) {
                this.valid = true;                        
            }

            this.editPayment = !this.editPayment;
             this.validateFormOnLoad();               
        },
        savePaymentData() {
            
            if ( this.valid ) {
                this.editPayment = false;
                let data = {
                    user_card_payment: {
                        name: this.cardName,
                        id: this.numberCard,
                        month: this.monthCard, 
                        year: this.yearCard,
                        type: this.typeCard
                    }                
                }

                this.loader = true;
                this.$store.dispatch('saveUserDetails', data);
                        
                this.viewCard = '**** **** **** ' + this.numberCard.toString().slice(-4);
            }
        },
    },
    computed: {
        loader() {
            return this.$store.getters.loader ?? false;
        },
    },
    async beforeMount() {        
    },
    watch: {
        userDetails(newData) {
            if(newData.card) {
                this.numberCard = newData.card.id;
                this.viewCard = '**** **** **** ' + newData.card.id.toString().slice(-4);
                this.cardName = newData.card.name;
                this.monthCard = newData.card.month;
                this.yearCard = newData.card.year;
                this.typeCard = newData.card.type;
            }
     
        }
    }

}
</script >
